import styled from "styled-components";
import { SPACING } from "../../../utils/constants";

export const ErrorMessage = styled.span`
  display: block;
  margin-top: ${SPACING.xs}px;
  color: var(--color-error);
  font-size: var(--text-xs);
`;
